import { Record } from 'immutable';
import { LOG_IN, LOG_OUT } from '../../modules/user/actions';
import { REGISTRATION_SUCCESS } from './actions';

export const InitialState = new Record({
  newOnlineAccount: false
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case LOG_IN:
    case LOG_OUT: {
      return state
        .set('newOnlineAccount', false);
    }
    case REGISTRATION_SUCCESS: {
      return state
        .set('newOnlineAccount', true);
    }
    default: {
      return state;
    }
  }
};
